import { Injectable } from '@angular/core';
import { LoginService } from './login.service'
import { Http, Headers, RequestOptions } from '@angular/http';

@Injectable()
export class UrlManagerService {

  /**
   * Test Environment
   */
  public isProduction: boolean = false;
  private url: string = "https://wqfrmjj1ve.execute-api.us-east-1.amazonaws.com/prd";
  private auth_service: string = "https://wqfrmjj1ve.execute-api.us-east-1.amazonaws.com/prd";

  /**
   * Production Environment
   */
  // private isProduction: boolean = true;
  // private url: string = "https://www.stlawrencesoftware.com/WfC/api";
  // private auth_service: string = "https://www.stlawrencesoftware.com/WfC/auth";
  


  constructor(private loginService: LoginService) { }

  public getApiUrl() {
    if (localStorage.getItem('currentUser') != null) {
      if (this.isProduction) {
        return this.url + "/" + JSON.parse(localStorage.getItem('currentUser')).instance;
      } else {
        return this.url;
      }
    }
  }

  public getAuthUrl() {
    return this.auth_service;
  }

  public getOptions() {
    if (localStorage.getItem('currentUser') != null) {
      var headers = new Headers();
      const cachedUser = JSON.parse(localStorage.getItem('currentUser'));
      console.log(cachedUser);
      headers.append('Authorization', cachedUser.token);
      headers.append('x-tenant',  cachedUser.tenant )
      headers.append('Content-Type', 'application/json');
      headers.append('Accept', 'application/json');
      var options = new RequestOptions({ headers: headers });
      return options;
    }
    return null;
  }

}



// WEBPACK FOOTER //
// ./src/app/Services/url-manager.service.ts